import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import styles from "../../Alumni/AlumniPages.module.css";

const API = process.env.REACT_APP_BACKEND_API_URL;

const AlumniApprovals = () => {
  const [status, setStatus] = useState("PENDING");
  const [search, setSearch] = useState("");
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [actioning, setActioning] = useState(null);

  const load = useCallback(() => {
    setLoading(true);
    axios
      .get(`${API}/api/alumni-admin/registration-requests`, { params: { status, search } })
      .then(({ data }) => setRequests(data.requests))
      .finally(() => setLoading(false));
  }, [status, search]);

  useEffect(() => {
    const t = setTimeout(load, 250);
    return () => clearTimeout(t);
  }, [load]);

  const approve = async (id) => {
    setActioning(id);
    try {
      await axios.post(`${API}/api/alumni-admin/registration-requests/${id}/approve`, {});
      load();
    } catch (err) {
      alert(err.response?.data?.error || "Failed to approve request.");
    } finally {
      setActioning(null);
    }
  };

  const reject = async (id) => {
    const remarks = window.prompt("Reason for rejection:");
    if (!remarks) return;
    setActioning(id);
    try {
      await axios.post(`${API}/api/alumni-admin/registration-requests/${id}/reject`, { remarks });
      load();
    } catch (err) {
      alert(err.response?.data?.error || "Failed to reject request.");
    } finally {
      setActioning(null);
    }
  };

  return (
    <div>
      <h1 className={styles.heading}>Alumni Registration Approvals</h1>
      <p className={styles.subheading}>Review identification details and approve or reject alumni sign-up requests.</p>

      <div className={styles.filterBar}>
        <select className={styles.select} value={status} onChange={(e) => setStatus(e.target.value)}>
          <option value="PENDING">Pending</option>
          <option value="APPROVED">Approved</option>
          <option value="REJECTED">Rejected</option>
        </select>
        <input
          className={styles.input}
          placeholder="Search by name, mobile or email"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {loading && <div className={styles.emptyState}>Loading requests...</div>}
      {!loading && requests.length === 0 && (
        <div className={styles.emptyState}>No {status.toLowerCase()} requests.</div>
      )}

      {!loading && requests.length > 0 && (
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Name</th>
              <th>Mobile</th>
              <th>Identification</th>
              <th>Document</th>
              <th>Submitted</th>
              {status === "PENDING" && <th>Actions</th>}
            </tr>
          </thead>
          <tbody>
            {requests.map((r) => (
              <tr key={r.request_id}>
                <td>{r.full_name}</td>
                <td>{r.mobile_number}</td>
                <td>
                  {r.identification_type}: {r.identification_no}
                </td>
                <td>
                  {r.identification_document ? (
                    <a href={`${API}${r.identification_document}`} target="_blank" rel="noreferrer">
                      View
                    </a>
                  ) : (
                    "—"
                  )}
                </td>
                <td>{new Date(r.created_at).toLocaleDateString()}</td>
                {status === "PENDING" && (
                  <td>
                    <div className={styles.actions}>
                      <button
                        className={styles.approveBtn}
                        disabled={actioning === r.request_id}
                        onClick={() => approve(r.request_id)}
                      >
                        Approve
                      </button>
                      <button
                        className={styles.rejectBtn}
                        disabled={actioning === r.request_id}
                        onClick={() => reject(r.request_id)}
                      >
                        Reject
                      </button>
                    </div>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default AlumniApprovals;
